import { RichTextEditor } from '@/components/editor/rich-text-editor';
import { useIsPageEditor } from '@/hooks/use-is-page-editor';
import { hasRichTextContent } from '@/lib/rich-text';

const PINNED_HEADING_CONTENT_CLASS =
  'block w-full [&_:is(h1,h2,h3,h4,h5,h6)]:m-0 [&_:is(h1,h2,h3,h4,h5,h6)]:scroll-m-20';

const PINNED_DESCRIPTION_CONTENT_CLASS = 'block w-full min-h-8 [&_p]:m-0';

export function PinnedSectionTextGroup({
  pinnedHeading,
  pinnedDescription,
}: {
  pinnedHeading: string;
  pinnedDescription?: string;
}) {
  const isEditor = useIsPageEditor();
  const showField = (value: string | undefined) => isEditor || hasRichTextContent(value);
  const showHeading = showField(pinnedHeading);
  const showDescription = showField(pinnedDescription);

  if (!showHeading && !showDescription) {
    return null;
  }

  return (
    <div className="space-y-3">
      {showHeading ? (
        <RichTextEditor
          value={pinnedHeading}
          fieldPosition="pinnedHeading"
          placeholder="Add a heading..."
          className={PINNED_HEADING_CONTENT_CLASS}
          headingsOnly
        />
      ) : null}
      {showDescription ? (
        <RichTextEditor
          value={pinnedDescription ?? ''}
          fieldPosition="pinnedDescription"
          placeholder="Add a description..."
          className={PINNED_DESCRIPTION_CONTENT_CLASS}
        />
      ) : null}
    </div>
  );
}
